import { render } from "./SavePageMarketSelection.vue?vue&type=template&id=3434f680"
import script from "./SavePageMarketSelection.vue?vue&type=script&lang=js"
export * from "./SavePageMarketSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__